// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  Master: {
    Code: null as string | null,  // Initialize with null or a default value
    Description: null as string | null,  // Initialize with null or a default value
  },
  St: {
    StatusDesc: null as string | null,  // Initialize with null or a default value
  }
  
};


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/environments/environment.ts